import React from 'react';
import { Helmet } from 'react-helmet';
import locations from '../data/locations.json';
import { LocationInfo } from '../components/LocationInfo';
import './contact.scss';
import { useLocationRoute } from '../data/locationRoutes';

export default function Contact() {
    const { shop } = useLocationRoute();
    const shops = shop ? [shop] : locations;
    return <div className={`location-page contact-page${shop ? ' contact-page--selected' : ''}`}>
        <Helmet>
            <title>{shop ? `${shop.city} Hours & Directions | GOLDWrench Automotive` : 'Contact GOLDWrench Automotive | Waynesboro & Staunton, VA'}</title>
            <meta name="description" content={shop ? `Find GOLDWrench ${shop.city} at ${shop.street}, VA ${shop.zip}. Call ${shop.displayPhone}. View opening hours and directions.` : "Contact GOLDWrench Automotive in Waynesboro or Staunton, Virginia. Find each shop’s address, phone number, opening hours and directions."} />
        </Helmet>
        <h1>{shop ? `${shop.city} hours & directions` : 'Contact GOLDWrench Automotive'}</h1>
        <div className="locations-grid">{shops.map(shop => <LocationInfo key={shop.id} shop={shop} />)}</div>
    </div>;
}
